import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  EditingState,
  SortingState,
  IntegratedSorting,
  DataTypeProvider,
} from '@devexpress/dx-react-grid'
import {
  Grid,
  VirtualTable,
  TableHeaderRow,
  TableEditRow,
  TableEditColumn,
} from '@devexpress/dx-react-grid-material-ui';

import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import Input from '@material-ui/core/Input';
import Icon from '@material-ui/core/Icon';

import MoneyFormat from './format/MoneyFormat.js';

import firebase from 'firebase/app';
require("firebase/firestore");

const styles = theme => ({

});

const getRowId = row => row.id;
const columns = [
  { name: 'id', title: 'ID' },
  { name: 'name', title: 'Name' },
  { name: 'unit', title: 'Unit' },
  { name: 'value', title: 'Value' },
  { name: 'price', title: 'Price' },
  { name: 'active', title: 'Active' },
];

const passUnit = [
  { id: "time", title: "Time", },
  { id: "day", title: "Day", },
  { id: "month", title: "Month", },
];

const IdTypeProvider = () => (
  <DataTypeProvider
    for={['id', 'name', 'value']}
    editorComponent={() => <div />}
  />
);

const UnitTypeProvider = () => (
  <DataTypeProvider
    for={['unit']}
    formatterComponent={({ value }) => {
      var unit = passUnit.find(unit => { return unit.id === value });
      return unit && unit.title;
    }}
    editorComponent={({ value, onValueChange }) => <div />}
  />
);

const PriceTypeProvider = () => (
  <DataTypeProvider
    for={['price']}
    formatterComponent={({ value }) => <MoneyFormat displayType='text' value={value} />}
    editorComponent={({ column, row, value, onValueChange }) =>
      <Input
        fullWidth
        value={value}
        onChange={event => onValueChange(parseInt(event.target.value.replace(/\D/g, ''), 10) || 0)}
        inputComponent={MoneyFormat}
      />
    }
  />
);

const ActiveTypeProvider = () => (
  <DataTypeProvider
    for={['active']}
    formatterComponent={({ value }) => <Icon>{value ? 'check' : 'close'}</Icon>}
    editorComponent={({ column, row, value, onValueChange }) =>
      <Checkbox
        checked={value}
        onChange={event => onValueChange(event.target.checked)}
      />
    }
  />
);

const commitChanges = ({ added, changed, deleted }) => {
  if (changed) {
    for (var rowId in changed) {
      var changedObj = changed[rowId];
      if (changedObj) {
        var newValue = {};
        if (changedObj.name) newValue.name = changedObj.name;
        if (changedObj.value) newValue.value = parseInt(changedObj.value, 10);
        if (changedObj.price) newValue.price = changedObj.price;
        if (changedObj.active) newValue.active = changedObj.active;
        firebase.firestore().collection("pass").doc(rowId).update(changedObj);
      }
    }
  }
};

class PassesTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      passes: this.props.passes,

      width: window.innerWidth,
      height: window.innerHeight,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      passes: Array.from(nextProps.passes),
    });
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  render() {
    // const { classes } = this.props;
    return (
      <Paper>
        <Grid
          rows={this.state.passes}
          getRowId={getRowId}
          columns={columns}>

          <IdTypeProvider />
          <UnitTypeProvider />
          <PriceTypeProvider />
          <ActiveTypeProvider />

          {/* State */}
          <EditingState onCommitChanges={commitChanges} />

          {/* Sorting */}
          <SortingState />
          <IntegratedSorting />

          <VirtualTable
            columnExtensions={[
              { columnName: 'id', width: 200 },
              { columnName: 'name', width: this.state.width - 261 - 48 - 200 - 150 - 100 - 100 - 100 - 80 },
              { columnName: 'unit', width: 100 },
              { columnName: 'value', width: 100 },
              { columnName: 'price', width: 100 },
              { columnName: 'active', width: 80 },
            ]}
            height={this.state.height - 112} />
          <TableHeaderRow showSortingControls />

          {/* Edit */}
          <TableEditRow />
          <TableEditColumn showEditCommand />

        </Grid>
      </Paper>
    );
  }
}

PassesTable.propTypes = {
  classes: PropTypes.object.isRequired,
  passes: PropTypes.array.isRequired,
};

export default withStyles(styles)(PassesTable);
